/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import { _object } from 'utils/interfaces'

import { pageService } from 'services'

import { Button, InputField } from 'components/form-inputs'


import ReactQuill from 'react-quill'

const EditPage = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(false)

  const [page, setPage] = useState<_object>({})

  const fetchDealDetails = () => {
    pageService.getPageDetails(id).then((results: _object) => {
      setPage(results)
    })
  }

  useEffect(() => {
    fetchDealDetails()
  }, [id])
  const validationSchema = Yup.object({
    title: Yup.string().required('Title is required'),
    slug: Yup.string().required('Slug is required')
  })

  const formik: any = useFormik({
    initialValues: {
      title: page?.title || '',
      slug: page?.slug || '',
      // short_description: page?.short_description || '',
      html_content: page?.html_content || '',
      status: page?.status || ''
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true)

      pageService.updatePage(id, values).then((results: _object) => {
        if (results.error === false) {
          fetchDealDetails()
          location.href = '/app/pages'
        }
        setLoading(false)
      })
    }
  })

  return (
    <>
      <div className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold">Edit Page</h1>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="grid grid-cols-2 gap-8">
          <div>
            <div className="mb-4">
              <InputField
                label="Page Name"
                type="text"
                id="title"
                name="title"
                value={formik.values.title}
                onChange={formik.handleChange}
                className="w-full rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
                placeholder="Page Name"
                required={true}
              />
            </div>
            <div className="mb-4">
              <InputField
                label="Slug"
                type="text"
                id="slug"
                name="slug"
                value={formik.values.slug}
                onChange={formik.handleChange}
                className="w-full rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
                placeholder="Slug"
                required={true}
              />
            </div>

            {/* <div className="mb-4">
              <InputField
                label="Short Description"
                type="text"
                name="short_description"
                value={formik.values.short_description}
                onChange={formik.handleChange}
                className="w-full rounded-md border px-3 py-2 text-sm font-medium text-gray-900 outline-none focus:outline-none"
                placeholder="Short Description"
              />
            </div> */}
            <div className="mb-4">
              <label
                htmlFor="html_content"
                className="mb-2 block text-sm font-medium text-gray-900"
              >
                Page description
              </label>
              <ReactQuill
                id="html_content"
                value={formik.values.html_content}
                onChange={(value: string) => formik.setFieldValue('html_content', value || '')}
                className="w-full text-sm outline-none focus:outline-none"
                placeholder="Page content"
              />
            </div>
            <div className="mb-5">
              <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
                Status
              </label>
              <div className="flex gap-6">
                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="status"
                    value="published"
                    checked={formik.values.status === 'published'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  Published
                </label>

                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="status"
                    value="draft"
                    checked={formik.values.status === 'draft'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required
                  />
                  Draft
                </label>
              </div>
            </div>
            <Button
              label="Submit"
              type="submit"
              className="mt-4 flex w-full justify-center rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950"
              loading={loading}
              disabled={!formik.isValid || !formik.dirty}
            />
          </div>
        </div>
      </form>
    </>
  )
}

export default EditPage
